<script>
import {
  ArrowUpIcon,
  MonitorIcon,
  FeatherIcon,
  EyeIcon,
  UserCheckIcon,
  UserIcon,
  SmartphoneIcon,
  HeartIcon,
  MailIcon,
  KeyIcon,
} from "vue-feather-icons";

import Vue from 'vue';
import { Carousel, Slide } from "vue-carousel";

import Navbar from "@/components/navbar";
import Switcher from "@/components/switcher";
import Footer from "@/components/footer";
import Pricing from "@/components/pricing2";
import Testimonial from "@/components/testimonial";

Vue.use(require('vue-moment'));

/**
 * Index application component
 */
export default {
  data() {
    return {
      data: {
        email: null,
        name: null,
      },
      mySubscription: {}

    };
  },
  components: {
    Navbar,
    Footer,
    MonitorIcon,
    FeatherIcon,
    EyeIcon,
    MailIcon,
    UserIcon,
    KeyIcon,
    UserCheckIcon,
    SmartphoneIcon,
    HeartIcon,
    ArrowUpIcon,
  },
  created(){
    this.$swal({
      title: 'Thank You!',
      text: 'Payment Success!',
      icon: 'success',
    }).then((result) => {
        this.$router.push('/')
    })
  },
};
</script>

<template>
  <div>
    <Navbar />
    
   
  </div>
</template>
